<template>
<div class="chapter">
<div class="inner_page">
<a href="https://murder-mayhem.com/newsletters/?utm_source=MNMGOAAAAI&amp;utm_campaign=9781504051453" target="_blank">
<img alt="image" class="svg_cover" src="images/mm-backad.jpg"/>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MM.vue?a0e29090